export default "__VITE_ASSET__$uzRWwEs__"